import React from 'react';
import { FiArrowRight, FiPlay } from 'react-icons/fi';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="beranda">
      <div className="container hero__container">
        <div className="hero__content">
          <span className="hero__badge">IT Solutions</span>
          <h1 className="hero__title">
            Solusi Jaringan Teknologi Terpercaya untuk{' '}
            <span className="hero__title-highlight">Masa Depan Digital Anda</span>
          </h1>
          <p className="hero__description">
            Menyediakan solusi IT dan infrastruktur jaringan end-to-end untuk bisnis yang ingin 
            bertransformasi digital. Dari konsultasi hingga implementasi, kami siap membantu 
            bisnis Anda tumbuh dengan teknologi terdepan.
          </p>
          <div className="hero__actions">
            <a href="#kontak" className="btn btn-primary">
              Konsultasi Gratis <FiArrowRight />
            </a>
            <a href="#tentang" className="btn btn-outline">
              <FiPlay /> Pelajari Layanan Kami
            </a>
          </div>
        </div>
        <div className="hero__image">
          <div className="hero__image-placeholder">
            <div className="hero__image-grid">
              <div className="hero__image-item hero__image-item--large"></div>
              <div className="hero__image-item hero__image-item--small"></div>
              <div className="hero__image-item hero__image-item--small"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
